module.exports = __webpack_public_path__ + "img/bg_week@2x.fc1e0681.png";